/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { WallItemStreemshotDetectionsDetectionFromJSON, WallItemStreemshotDetectionsDetectionToJSON, } from './';
export function WallItemStreemshotDetectionsFromJSON(json) {
    return WallItemStreemshotDetectionsFromJSONTyped(json, false);
}
export function WallItemStreemshotDetectionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'detections': !exists(json, 'detections') ? undefined : (json['detections'].map(WallItemStreemshotDetectionsDetectionFromJSON)),
        'streemshotId': !exists(json, 'streemshot_id') ? undefined : json['streemshot_id'],
    };
}
export function WallItemStreemshotDetectionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'detections': value.detections === undefined ? undefined : (value.detections.map(WallItemStreemshotDetectionsDetectionToJSON)),
        'streemshot_id': value.streemshotId,
    };
}
//# sourceMappingURL=WallItemStreemshotDetections.js.map